<template>
  <div class="tab">
    <div
      class="tab-item"
      :class="currentIndex == index ? 'active' : ''"
      v-for="(tab, index) in tabs"
      :key="index"
      @click="handleTabClick(tab, index)"
    >
      {{ tab.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "smcaiot-tab",
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    handleTabClick(item, index) {
      this.currentIndex = index;
      this.$emit("handleTabClick", item);
    }
  }
};
</script>

<style lang="less" scoped>
.tab {
  padding-top: 6rem;
  padding-bottom: 3.65rem;
  display: flex;
  justify-content: center;
  .tab-item {
    width: 13rem;
    height: 4.8rem;
    line-height: 4.8rem;
    border: 1px solid #999999;
    font-size: 1.1rem;
    color: #333333;
    text-align: center;
    background-color: #ffffff;
    &.active {
      color: #ffffff;
      background: linear-gradient(180deg, #1f99e1 0%, #2f61ae 100%);
      border: 1px solid #ffffff;
    }
    &:first-child {
      margin-right: 3rem;
    }
  }
}
</style>
